<template>
    <div>
        <h1>{{ transl["STR_TITLE_TESTS"] }}</h1>
        <div class="developer" v-if="this.$store.getters.developer">
            <b>Entwickler Ausgabe:</b>
            <pre v-html="filteredTests"></pre>
        </div>

        <table v-if="cycler.length > 1">
            <tr>
                <td width="100"><b>Ger&auml;te Filter:</b></td>
                <td>
                    <select v-model="devicefilter">
                        <option value="99">Alle Ger&auml;te</option>
                        <option v-for="c in cycler" v-bind:key="c.serial" :value="c.serial">{{ c.nick}}</option>
                    </select>
                </td>
            </tr>
        </table>

        <table border="1">
        <thead>
            <th width="140">{{transl["STR_DATE_TIME"]}}</th>
            <th width="80" class="hideonmobile">{{transl["STR_PROBES"]}}</th>
            <th width="90">{{transl["STR_POSITIVES"]}}</th>
            <th width="90">{{transl["STR_INVALIDS"]}}</th>
            <th width="90" class="hideonmobile">{{ transl["STR_TEST_TYPE"]}}</th>
            <th width="100">{{ transl["STR_DEVICE"]}}</th>
            <th width="140">{{ transl["STR_ACTIONS"]}}</th>
        </thead>
        <tr v-for="t in filteredTests" v-bind:key="t.testid">
            <td>&nbsp;
                <span class="hideonmobile">{{ t.time | unixtimestamp(true) }}</span>
                {{ t.time | unixtimestamp }}
            </td>    
            <td align="center" class="hideonmobile">{{ t.probes }}</td>
            <td align="center" :class="{ 'positive' : t.probesPositive > 0 }">{{ t.probesPositive }}</td>
            <td align="center" :class="{ 'invalid' : t.probesInvalid > 0 }">{{ t.probesInvalid }}</td>
            <td align="center" class="hideonmobile">{{ t.target }}</td>
            <td>&nbsp;{{ getNick(t.cycler) }}</td>
            <td align="center">
                <u style="cursor: pointer;text-decoration: none;" v-on:click="getThisTest(t.testid)">
                    {{ transl["STR_ACT_SHOW"]}}
                </u>
                <span  class="hideonmobile">&nbsp;|&nbsp;
                    <!--
                <u style="cursor: pointer;text-decoration: none;" v-on:click="getCSV(t.testid, t.cycler)">CSV</u></span>&nbsp;|&nbsp;
                -->
                <u style="cursor: pointer;text-decoration: none;" v-on:click="getPDF(t.testid)">PDF</u></span>             
            </td>
        </tr>
        <tr v-if="!filteredTests.length">
            <td colspan="7" style="padding: 10px;">Sie haben bisher noch keine Tests durchgef&uuml;hrt.</td>
        </tr>
        <tr v-if="devicefilter == 99 && filteredTests.length">
            <td colspan="50">
                <table style="width: 100%">
                <tfoot>
                    <tr>
                        <td><button v-on:click="page--" :disabled="(this.offset*this.page)-this.offset == 0">&larr;</button></td>
                        <td colspan="3" align="center">Test {{ (this.offset*this.page)-this.offset }} bis  {{ this.offset*this.page }} von {{ this.$store.getters.tests.length }}</td>
                        <td align="right"><button v-on:click="page++" :disabled="this.offset*this.page > this.$store.getters.tests.length">&rarr;</button></td>
                    </tr>
                </tfoot>
                </table>  
            </td>
        </tr>
        </table>
        
        <div style="display: Flex">
            <div class="magic-button" style="margin-right: 15px" v-on:click="getToday">
                {{ transl["STR_DOWNLOAD_TODAY"]}}
            </div>

            <div class="magic-button" v-on:click="FQDConverter" v-if="curves">
                FQD Importieren
            </div>
        </div>

    </div>
</template>
<script>


export default({
    props: [ 'curves','transl' ],
    filters: {
        unixtimestamp(UNIX_timestamp, aa) {
            var a = new Date(UNIX_timestamp * 1000);
            var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
            var year = a.getFullYear();
            var month = a.getMonth()+1;
            var date = a.getDate();
            var hour = a.getHours();
            var min = a.getMinutes();
            var sec = a.getSeconds();
            if(sec < 10) sec="0"+sec;

            if(date < 10) date="0"+date;
            if(month < 10) month="0"+month;
            if(hour < 10) hour="0"+hour;
            if(min < 10) min="0"+min;
            
            if(aa) {
                var time = date + '.' + month + '.' + year;
            } else {
                var time = hour + ':' + min + ':' + sec ;
            }
            return time;            
        }
    },
    data() {
        return {
            start: 0,
            offset: 20,
            page: 1,
            nicks: [],
            cycler: [],
            devicefilter: 99,
        }
    },
    computed: {
        filteredTests() {
            if(!this.$store.getters.tests.length) return {}

            if(this.devicefilter == 99) {
                return this.$store.getters.tests.slice((this.offset*this.page)-this.offset,this.offset*this.page)
            }
            if(this.devicefilter !== 99) {
                return this.$store.getters.tests.filter(e => e.cycler == this.devicefilter)
            }
            return this.$store.getters.tests.slice((this.offset*this.page)-this.offset,this.offset*this.page)
        }
    },
    mounted() {
        this.loadNicks();
        let { device = false } = this.$route.params;
        if(device) {
            this.devicefilter = device;
            this.hideFilter = true;
        }
    },
    methods: {
        FQDConverter() {
            this.$router.push({
                name: 'fqd',
            })
        },
        getToday() {
            var token = this.$store.getters.accessToken;
            window.open("/api/exporttoday?token="+token)
        },
        getNick(id) {
            var mm = this.nicks.find(e => e.serial == id);
            if(mm) {
                return mm.name;
            } else {
                if(id.trim() == "") return "N/A";
                return id;
            }
        },
        ShowCurves(id) {
            console.log(id.testid);
            this.$router.push({
                name: 'ShowCurves',
                params: {
                    testid: id.testid,
                }
            })
        },

        loadNicks() {
            this.nicks = [];
            this.$store.getters.cyclers.forEach((c) => {
                this.nicks.push({
                    serial: c.serial,
                    name: c.name,
                })
            })
        },
        nickname(serial) {
            var find = this.nicks.find(e => e.serial == serial);
            if(find) {
                return find.nick;
            } else {
                return serial;
            }
        },
        getCurves(id) {
            this.$router.push({
                name: 'ShowCurves',
                params: {
                    testid: id,
                }
            })
        },
        getPDF(id) {
            document.cookie = "authtoken=" + (this.$store.getters.accessToken || "")  + "; max-age="+(60*5)+"; secure=true; path=/test/"+id+"/pdf; SameSite=Strict";
            if(this.curves) {
                window.open("/test/"+id+"/pdf?extended=true");
            } else {
                window.open("/test/"+id+"/pdf");
            }
        },
        getCSV(id, serial) {
            this.$store.dispatch("LoadProbes", id)
            .then((probes) => {
                var csv = "Barcode;Device;Position;Valid;CT;Positive\n";
                var cycler = this.nickname(serial);
                probes.filter(e => e.barcode.substr(3) !== "NTC" && e.barcode.substr(3) !== "TPC").forEach((p) => {
                    csv+="'"+p.barcode+"';"+cycler+";"+p.well+";"+p.valid+";"+(p.positive && p.valid ? p.ct : "-")+";"+p.positive+"\n";
                })
                var element = document.createElement('a');
                element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(csv));
                element.setAttribute('download', id+'.csv');
                element.style.display = 'none';
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);                
            })
        },
        getThisTest(id) {
            this.$store.dispatch("LoadProbes", id)
            .then((r) => {
                this.$router.push({
                    name: 'ShowThisTest',
                    params: {
                        id: id,
                    }
                })
            })
        }
    }
})
</script>
